module.exports = __webpack_public_path__ + "images/emoji/smiley.361e57996884356dad35.png";